import React from 'react';
import InfoIcon from 'material-ui/svg-icons/action/info';
import NumberField from '../../../Base/NumberField';

const FIELDS = {
    loa: { label: 'LOA' },
    lbp: { label: 'LBP' },
    beam: { label: 'Beam' },
    depth: { label: 'Depth' },
    beamMoulded: { label: 'Beam moulded' },
    depthMoulded: { label: 'Depth moulded' },
    bowToCenterManifold: { label: 'Bow to center manifold' },
    keelToMast: { label: 'Keel to mast' },
    airdrftLightship: { label: 'Airdrft / lightship' },
    airdrftNormBallast: { label: 'Airdrft / norm ballast' },
    airdrftLoadSumDwt: { label: 'Airdrft / load sum dwt' },
    wltohcBallast: { label: 'WLTOHC / ballast', hint: 'Waterline to hatch coaming' },
    wltohcDeball: { label: 'WLTOHC / deballast', hint: 'Waterline to hatch coaming' },
    bwtlhc: { label: 'BWTLHC', hint: 'Bow to aft last hatch' },
    parallelBodyLoaded: { label: 'Parallel body loaded' },
    parallelBodyFore: { label: 'Parallel body fore' },
    parallelBodyAft: { label: 'Parallel body aft' },
    sttbr: { label: 'STTBR', hint: 'Distance fm stern to bridge' },
    bwtbr: { label: 'BWTBR', hint: 'Distance fm bow to bridge' },
    freshWaterAllowance: { label: 'Frsh wtr allwnce fwa' },
    dtcr: { label: 'DTCR', hint: 'Height from deck to top of the crane' },
};

const LAYOUT = [
    [
        'loa', 'lbp', 'beam', 'depth', 'beamMoulded', 'depthMoulded',
        'bowToCenterManifold', 'keelToMast', 'airdrftLightship',
        'airdrftNormBallast', 'airdrftLoadSumDwt',
    ],
    ['wltohcBallast', 'wltohcDeball', 'bwtlhc'],
    [
        'parallelBodyLoaded', 'parallelBodyFore', 'parallelBodyAft', 'sttbr',
        'bwtbr', 'freshWaterAllowance', 'dtcr',
    ],
];

const styles = {
    infoIcon: {
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        margin: '-3px 0 0 0.5em',
        color: '#dadada',
        cursor: 'pointer',
    },
};

function Dimensions({ confirmed, changeField, getError, underStyle, modifiedFields, dimensions }) {
    return (
        <React.Fragment>
            {LAYOUT.map(fields => (
                <div className='row' key={fields[0]}>
                    {fields.map(field => (
                        <div className='col-xs-3' key={field}>
                            <NumberField
                                name={field}
                                value={dimensions[field] || ''}
                                floatNumber
                                floatingLabelText={
                                    <React.Fragment>
                                        {FIELDS[field].label}
                                        {!!FIELDS[field].hint && (
                                            <span
                                                data-tip={FIELDS[field].hint}
                                                style={{ pointerEvents: 'all' }}
                                            >
                                                <InfoIcon style={styles.infoIcon} />
                                            </span>
                                        )}
                                    </React.Fragment>
                                }
                                disabled={confirmed}
                                min={0}
                                onChange={(e, value) => {
                                    changeField({
                                        field: `dimensions.${field}`,
                                        value,
                                    });
                                }}
                                errorText={getError(`dimensions.${field}`)}
                                fullWidth
                                underlineStyle={modifiedFields && modifiedFields.includes(`dimensions.${field}`) ? underStyle : null}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </React.Fragment>
    );
}

export default Dimensions;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Dimensions.jsx